import { LegalLayout, LegalSection } from "../components/site/LegalLayout";
import { WHATSAPP_DISPLAY } from "../lib/site";

export default function Privacidade() {
  return (
    <LegalLayout title="Política de Privacidade" updatedAt="18 de agosto de 2026">
      <p>
        Esta Política de Privacidade descreve como o Delivery Maracás coleta, utiliza, armazena e
        protege os dados pessoais dos usuários do aplicativo e do site www.deliverymaracas.com.br,
        em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD).
      </p>

      <LegalSection n="1" title="Dados que coletamos">
        <p>Podemos coletar as seguintes categorias de dados:</p>
        <ul className="list-disc space-y-1 pl-6">
          <li><strong>Dados cadastrais:</strong> nome, e-mail, telefone e senha.</li>
          <li><strong>Dados de entrega:</strong> endereço, ponto de referência e localização.</li>
          <li><strong>Dados de pedidos:</strong> itens, histórico, preferências e avaliações.</li>
          <li><strong>Dados de pagamento:</strong> processados por parceiros; não armazenamos o número completo do cartão.</li>
          <li><strong>Dados técnicos:</strong> modelo do dispositivo, sistema operacional, identificadores e dados de uso do app.</li>
        </ul>
      </LegalSection>

      <LegalSection n="2" title="Como usamos seus dados">
        <p>Utilizamos os dados para:</p>
        <ul className="list-disc space-y-1 pl-6">
          <li>Processar e entregar seus pedidos e agendamentos;</li>
          <li>Autenticar seu acesso e manter a segurança da conta;</li>
          <li>Comunicar status de pedidos, promoções e novidades (quando autorizado);</li>
          <li>Melhorar a Plataforma, prevenir fraudes e cumprir obrigações legais.</li>
        </ul>
      </LegalSection>

      <LegalSection n="3" title="Compartilhamento de dados">
        <p>
          Compartilhamos apenas os dados necessários com: lojas parceiras (para preparar o pedido),
          entregadores (para realizar a entrega), processadores de pagamento e prestadores de
          serviço tecnológico. Não vendemos seus dados pessoais a terceiros.
        </p>
      </LegalSection>

      <LegalSection n="4" title="Cookies e tecnologias similares">
        <p>
          Utilizamos cookies e identificadores para lembrar preferências, manter sessões e analisar
          o uso do site e do app. Você pode gerenciar cookies nas configurações do seu navegador.
        </p>
      </LegalSection>

      <LegalSection n="5" title="Armazenamento e segurança">
        <p>
          Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não
          autorizado, perda ou alteração. Os dados são mantidos pelo tempo necessário às finalidades
          descritas ou conforme exigido por lei.
        </p>
      </LegalSection>

      <LegalSection n="6" title="Seus direitos (LGPD)">
        <p>Você pode, a qualquer momento, solicitar:</p>
        <ul className="list-disc space-y-1 pl-6">
          <li>Confirmação da existência e acesso aos seus dados;</li>
          <li>Correção de dados incompletos ou desatualizados;</li>
          <li>Anonimização, bloqueio ou eliminação de dados desnecessários;</li>
          <li>Portabilidade e revogação do consentimento.</li>
        </ul>
      </LegalSection>

      <LegalSection n="7" title="Retenção e exclusão">
        <p>
          Ao encerrar sua conta, seus dados serão eliminados ou anonimizados, ressalvadas as
          hipóteses de guarda obrigatória previstas em lei (por exemplo, obrigações fiscais).
        </p>
      </LegalSection>

      <LegalSection n="8" title="Menores de idade">
        <p>
          A Plataforma não é destinada a menores de 18 anos sem o consentimento e supervisão de um
          responsável legal.
        </p>
      </LegalSection>

      <LegalSection n="9" title="Alterações desta Política">
        <p>
          Esta Política pode ser atualizada a qualquer momento. A versão vigente estará sempre
          publicada nesta página, com a data da última atualização.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Encarregado e contato">
        <p>
          Para exercer seus direitos ou tirar dúvidas sobre privacidade, entre em contato pelo
          e-mail contato@deliverymaracas.com.br ou pelo WhatsApp {WHATSAPP_DISPLAY}.
        </p>
        <p className="text-sm text-maraca-navy/50">
          Controlador: [Razão Social] — CNPJ: [00.000.000/0001-00] — Maracás/BA.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
